import { render, staticRenderFns } from "./SpecialSixTitle.vue?vue&type=template&id=ca0d5880&scoped=true"
import script from "./SpecialSixTitle.vue?vue&type=script&lang=js"
export * from "./SpecialSixTitle.vue?vue&type=script&lang=js"
import style0 from "./SpecialSixTitle.vue?vue&type=style&index=0&id=ca0d5880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0d5880",
  null
  
)

export default component.exports